import request from 'utils/request';

export const createTopups = payload => request.post('/topups', payload);
